import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const IOS_STORE =
  "https://apps.apple.com/us/app/vupop/id6747295116";
const IOS_STORE_APP =
  "itms-apps://apps.apple.com/us/app/vupop/id6747295116";
const ANDROID_STORE =
  "https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share";

function isIOS() {
  const ua = navigator.userAgent || navigator.vendor || "";

  if (/iPad|iPhone|iPod/i.test(ua)) return true;
  if (/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua)) return true;

  if (
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1 &&
    /MacIntel|Macintosh/i.test(ua)
  ) {
    return true;
  }

  return false;
}

function isMacDesktop() {
  const ua = navigator.userAgent || "";
  if (isIOS()) return false;

  return (
    /^Mac/i.test(navigator.platform || "") ||
    (/Macintosh|Mac OS X/i.test(ua) && !/Mobile/i.test(ua))
  );
}

function isWindows() {
  const ua = navigator.userAgent || "";
  return (
    /Windows/i.test(ua) ||
    /Win32|Win64|WOW64/i.test(navigator.platform || "")
  );
}

function detectPlatform() {
  if (isIOS()) return "ios";
  if (/android/i.test(navigator.userAgent || "")) return "android";
  if (isWindows()) return "windows";
  if (isMacDesktop()) return "mac";
  return "other";
}

function redirectTo(url) {
  window.location.href = url;
}

const ReferralRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const platform = detectPlatform();

    if (platform === "ios") {
      let handled = false;
      let cancelTimer = null;
      let fallbackTimer = null;

      const cleanup = () => {
        clearTimeout(cancelTimer);
        clearTimeout(fallbackTimer);
        document.removeEventListener("visibilitychange", onVisibilityChange);
      };

      const goToAppFallback = () => {
        if (handled || document.visibilityState !== "visible") return;
        handled = true;
        cleanup();
        navigate("/app", { replace: true });
      };

      const onVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          clearTimeout(cancelTimer);
          cancelTimer = setTimeout(goToAppFallback, 300);
        } else {
          clearTimeout(cancelTimer);
        }
      };

      document.addEventListener("visibilitychange", onVisibilityChange);

      redirectTo(IOS_STORE_APP);
      fallbackTimer = setTimeout(goToAppFallback, 2000);

      return cleanup;
    }

    if (platform === "android" || platform === "windows" || platform === "other") {
      redirectTo(ANDROID_STORE);
      return;
    }

    if (platform === "mac") {
      redirectTo(IOS_STORE);
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center font-League_Spartan">
      <p className="text-white text-sm">Redirecting...</p>
    </div>
  );
};

export default ReferralRedirect;
